import { putResolve, takeEvery } from 'redux-saga/effects';
import { getType } from 'deox';
import { setStoreUser, setUser } from 'modules/user';
import { put } from 'redux-saga-test-plan/matchers';
import {
  clearSrcForShutterstockImages,
  deleteAllScenes,
  loadActualShutterstockUrls,
  makeScenesWithoutSrcEmpty
} from 'modules/scenes';
import { deleteAllEffects } from 'modules/effects';
import { restoreDownloading } from 'modules/downloading';
import { getUrlParametr } from 'utils/utils';
import { getProjectFilesList } from 'modules/projectFles';
import { loadUserPaidItems } from 'modules/oneTimePayment';
import { User } from 'types/User';

function* updateScenesData() {
  yield put(makeScenesWithoutSrcEmpty());
  yield put(clearSrcForShutterstockImages());
  yield put(loadActualShutterstockUrls());
}

function* restoreProjectsState(userId: User['id']) {
  yield putResolve(getProjectFilesList(userId));
  yield putResolve(loadUserPaidItems());
  yield applyTemplateFromUrl();
  yield updateScenesData();
  yield put(restoreDownloading());
}

export function* setUserSaga({ payload }: ReturnType<typeof setUser>) {
  if (payload && payload.key && payload.id) {
    yield put(setStoreUser(payload));
    yield restoreProjectsState(payload.id);
  }
}

function* applyTemplateFromUrl() {
  const templateId = getUrlParametr('templateId');

  if (templateId) {
    yield put(deleteAllScenes());
    yield put(deleteAllEffects());
  }
}

export function* userSaga() {
  yield takeEvery(getType(setUser), setUserSaga);
}
